export enum PaymentMethod {
  CARD = 'card',
  LINK = 'link',
  US_BANK_ACCOUNT = 'us_bank_account',
  AU_BECS_DEBIT = 'au_becs_debit',
  CASH = 'cash',
  CHECK = 'check',
}

export interface LoadWalletBalanceRequest {
  amount: number;
  paymentMethod: PaymentMethod;
  paymentDate?: string;
  note?: string;
  checkNumber?: string;
  chargePaymentMethod?: boolean;
}

export interface WalletBalanceResponse {
  walletBalance: number; // in dollars
  hasPendingAchWalletLoad?: boolean;
}

export interface LoadWalletBalanceResponse {
  status?: 'success' | 'pending';
  message: string;
  balance?: number;
  data?: unknown;
  hasPaymentMethod?: boolean;
}

export interface RemoveWalletBalanceRequest {
  amount: number;
  note?: string;
  paymentDate?: string;
}

export interface RemoveWalletBalanceResponse {
  status: 'success';
  message: string;
  balance: number;
}

export interface ErrorResponse {
  status: 'fail';
  message: string;
}
